<template>
  <ul class="pdl-media-object-list">
    <slot />
  </ul>
</template>

<script>
export default {};
</script>

<style lang="scss">
@import 'MediaObjectList.scss';
</style>
